import { useScrollFadeIn } from '../../../hooks/useScrollFadeIn';

export default function Testimonials() {
  const { ref, isVisible } = useScrollFadeIn({ delay: 200 });
  const testimonials = [
    {
      id: 1,
      name: '箕輪 拓真',
      initial: '箕',
      occupation: 'ITエンジニア',
      rating: 5,
      comment: '在宅勤務が増えて腰痛に悩んでいましたが、MeVER Chair Pro v2を使わせていただいてからリアルに改善しました。6Dアームレストが想像以上に便利で、もう手放せません。',
      verified: true,
    },
    {
      id: 2,
      name: '佐藤 太一',
      initial: '佐',
      occupation: 'グラフィックデザイナー',
      rating: 5,
      comment: '以前使っていた椅子は某量販店で購入した3万円程度のイスでしたが、結論MeVERに投資して良かったです。正直、悪い姿勢でもイスが合わせてくれるので、集中力が維持できます。',
      verified: true,
    },
    {
      id: 3,
      name: '山田 雄一',
      initial: '山',
      occupation: '経営コンサルタント',
      rating: 5,
      comment: '仕事柄、1日10時間以上座ることもあるのですが、この椅子は本当に疲れにくい。特にランバーサポートの調整幅が広く、6Dアームレストや16ヶ所の調整ヶ所と範囲の広さが凄まじいです。',
      verified: true,
    },
    {
      id: 4,
      name: '鈴木 彩香',
      initial: '鈴',
      occupation: 'フリーランスライター',
      rating: 5,
      comment: '友人を通してご紹介を頂き、思い切って購入。届いてすぐに違いを実感しました。座面の硬さが絶妙で、このイスの独特な首・腕・腰・ヒップのサポートされ具合を味わってしまうと、他のイスに座った時には違和感を感じるほどです。',
      verified: true,
    },
  ];

  return (
    <section
      ref={ref}
      className={`py-16 md:py-32 px-5 md:px-10 bg-[#f5f5f7] transition-all duration-1000 ease-out ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-0 md:px-10">
        
        {/* 統計情報 — 上部に配置 */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-20 mb-12 md:mb-20">
          <div className="text-center">
            <p className="text-4xl md:text-6xl font-bold text-gray-900 mb-2 tracking-tight">4.9</p>
            <div className="flex items-center gap-1 mb-2 justify-center">
              {[...Array(5)].map((_, i) => (
                <span key={i} className="w-4 h-4 md:w-4 md:h-4 flex items-center justify-center text-purple-600">
                  <i className="ri-star-fill text-sm"></i>
                </span>
              ))}
            </div>
            <p className="text-xs md:text-xs text-gray-400 tracking-wide">平均評価</p>
          </div>
          <div className="text-center">
            <p className="text-4xl md:text-6xl font-bold text-gray-900 mb-2 tracking-tight">96</p>
            <p className="text-xs md:text-xs text-gray-400 mt-3 tracking-wide">レビュー件数</p>
          </div>
          <div className="text-center">
            <p className="text-4xl md:text-6xl font-bold text-gray-900 mb-2 tracking-tight">98%</p>
            <p className="text-xs md:text-xs text-gray-400 mt-3 tracking-wide">満足度</p>
          </div>
        </div>

        {/* ラベル */}
        <div className="text-center mb-10 md:mb-20">
          <p className="text-[10px] tracking-[0.4em] uppercase text-gray-400 font-medium mb-3 md:mb-4">
            Customer Reviews
          </p>
          <h2 className="text-2xl md:text-5xl font-bold text-gray-900 tracking-tight">
            テスター購入者の声
          </h2>
        </div>

        {/* レビューグリッド */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-2xl p-5 md:p-10 border border-gray-200 hover:border-gray-300 transition-all duration-300"
            >
              {/* 星評価 */}
              <div className="flex items-center gap-1 mb-4 md:mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-purple-600">
                    <i className="ri-star-fill text-sm md:text-base"></i>
                  </span>
                ))}
              </div>

              {/* コメント */}
              <p className="text-sm md:text-base text-gray-600 leading-[1.8] mb-5 md:mb-8">
                {testimonial.comment}
              </p>

              {/* ユーザー情報 */}
              <div className="flex items-center gap-3 pt-4 border-t border-gray-200">
                <div className="w-11 h-11 md:w-12 md:h-12 rounded-full flex-shrink-0 bg-purple-100 flex items-center justify-center">
                  <span className="text-base md:text-lg font-bold text-purple-700">{testimonial.initial}</span>
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm md:text-sm font-semibold text-gray-900">{testimonial.name}</p>
                    {testimonial.verified && (
                      <span className="inline-flex items-center gap-1 px-2 py-1 bg-purple-50 border border-purple-200 text-purple-700 text-[10px] md:text-[10px] font-semibold tracking-wide rounded-full whitespace-nowrap">
                        <span className="w-3 h-3 flex items-center justify-center">
                          <i className="ri-checkbox-circle-fill text-xs"></i>
                        </span>
                        購入済み
                      </span>
                    )}
                  </div>
                  <p className="text-xs md:text-xs text-gray-500">{testimonial.occupation}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}